/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  logEvent,
  setUserId,
  isSupported,
  getAnalytics,
} from "firebase/analytics";
import { RootState } from "app/store";
import { AnalyticsEventType } from "app/types";
import { isProd } from "common/utils";

export const useAnalytics = () => {
  const location = useLocation();
  const analytics = getAnalytics();
  const [isAnalytics, setIsAnalytics] = useState(false);
  const user = useSelector((state: RootState) => state.user.appUser);

  const handleVisibilityState = useCallback(() => {
    if (user.active) {
      logEvent(
        analytics,
        document.visibilityState === "visible"
          ? AnalyticsEventType.ACTIVE
          : AnalyticsEventType.BACKGROUND,
        {
          page_path: location.pathname,
          page_title: location.pathname,
        }
      );
    }
  }, [user.active?.uid]);

  useEffect(() => {
    isSupported().then((supported) => setIsAnalytics(supported));

    document.addEventListener("visibilitychange", handleVisibilityState);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityState);
    };
  }, []);

  useEffect(() => {
    if (analytics) {
      setUserId(analytics, user.active?.uid);
    }
  }, [analytics, user.active?.uid]);

  useEffect(() => {
    if (isProd && isAnalytics && analytics) {
      logEvent(analytics, "page_view", {
        page_path: location.pathname,
        page_title: location.pathname,
      });
    }
  }, [location]);
};
